// Marketing site JS bundle. Standalone from application.js — different layout, different design system.
import { Application } from "@hotwired/stimulus";
import "@hotwired/turbo-rails";
import "@tailwindplus/elements";

import ConversationDemoController from "../components/marketing/sections/conversation_demo_component_controller";
import NavbarCtaController from "../components/marketing/sections/navbar_cta_controller";

const Stimulus = Application.start();
Stimulus.debug = false;

Stimulus.register(
  "marketing--sections--conversation-demo",
  ConversationDemoController,
);
Stimulus.register("marketing--sections--navbar-cta", NavbarCtaController);
